{
    "up.common.cancel": "取消",
    "up.common.confirm": "确定",
    "up.common.start": "开始",
    "up.common.end": "结束",
    "up.common.stop": "停止",
    "up.common.copy": "复制",
    "up.common.none": "暂无",
    "up.common.tip": "提示",
    "up.common.success": "成功",
    "up.common.fail": "失败",
    "up.common.close": "关闭",
    "up.common.preview": "预览",
    "up.common.re-select": "重选",
    "up.common.rotate": "旋转",
    "up.common.pleaseChoose": "请选择",
    "up.common.loading": "加载中",
    "up.common.loading2": "正在加载",
    "up.common.inOperation": "操作中",
    "up.common.settings": "设置",
    "up.common.retry": "重试",
    "up.common.search": "搜索",
    "up.common.more": "更多",
    "up.common.video": "视频",
    "up.common.file": "文件",
    "up.week.one": "一",
    "up.week.two": "二",
    "up.week.three": "三",
    "up.week.four": "四",
    "up.week.five": "五",
    "up.week.six": "六",
    "up.week.seven": "日",
    "up.barcode.error": "生成条码失败",
    "up.calendar.chooseDates": "日期选择",
    "up.calendar.disabled": "该日期已禁用",
    "up.calendar.daysExceed": "选择天数不能超过{days}天",
    "up.cityLocate.locateCity": "定位城市",
    "up.cityLocate.fail": "定位失败，请点击重试。",
    "up.cityLocate.locating": "定位中",
    "up.code.send": "获取验证码",
    "up.code.resendAfter": "X秒重新获取",
    "up.code.resend": "重新获取",
    "up.cropper.emptyWidhtOrHeight": "裁剪框的宽或高没有设置",
    "up.empty.car": "购物车为空",
    "up.empty.page": "页面不存在",
    "up.empty.search": "没有搜索结果",
    "up.empty.address": "没有收货地址",
    "up.empty.wifi": "没有WiFi",
    "up.empty.order": "订单为空",
    "up.empty.coupon": "没有优惠券",
    "up.empty.favor": "暂无收藏",
    "up.empty.permission": "无权限",
    "up.empty.history": "无历史记录",
    "up.empty.news": "无新闻列表",
    "up.empty.message": "消息列表为空",
    "up.empty.list": "列表为空",
    "up.empty.data": "数据为空",
    "up.empty.comment": "暂无评论",
    "up.link.copyed": "链接已复制，请在浏览器打开",
    "up.loadmoe.loadmore": "加载更多",
    "up.loadmoe.nomore": "没有更多了",
    "up.noNetwork.text": "哎呀，网络信号丢失",
    "up.noNetwork.pleaseCheck": "请检查网络，或前往",
    "up.noNetwork.connect": "网络已连接",
    "up.noNetwork.disconnect": "无网络连接",
    "up.pagination.previous": "上一页",
    "up.pagination.next": "下一页",
    "up.pullRefresh.pull": "下拉刷新",
    "up.pullRefresh.release": "释放刷新",
    "up.pullRefresh.refreshing": "正在刷新",
    "up.readMore.expand": "展开阅读全文",
    "up.readMore.fold": "收起",
    "up.search.placeholder": "请输入关键字",
    "up.signature.penSize": "笔画大小",
    "up.signature.penColor": "笔画颜色",
    "up.upload.sizeExceed": "超过大小限制",
    "up.upload.uploading": "上传中",
    "up.upload.previewImageFail": "预览图片失败",
    "up.upload.previewVideoFail": "预览视频失败",
    "up.goodsSku.stock": "库存",
    "up.goodsSku.price": "价格",
    "up.goodsSku.amount": "件",
    "up.goodsSku.choosed": "已选",
    "up.goodsSku.buyAmount": "购买数量"
}
